@let hasAdministrationUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Administration);
@let forbiddenPermissionsMessage = 'general.forbidden_action' | translate;
<div class="list-height ms-4">
  <div>
    <h4 class="mb-2">
      {{ 'page.settings.company_settings.activity_categories' | translate }}
    </h4>
    <div class="mb-2">
      {{
        'page.settings.company_settings.activity_categories_description'
          | translate
      }}
    </div>

    <nz-alert
      nzType="warning"
      [nzMessage]="
        'page.settings.company_settings.activity_categories_warning_title'
          | translate
      "
      [nzDescription]="warningDescTpl"
      nzShowIcon
      class="mb-3"
    ></nz-alert>

    <ng-template #warningDescTpl>
      {{
        'page.settings.company_settings.activity_categories_warning_description'
          | translate
      }}
      <a
        [href]="
          'page.settings.company_settings.activity_categories_handbook_url'
            | translate
        "
        target="_blank"
        rel="noopener"
        >{{
          'page.settings.company_settings.activity_categories_warning_link'
            | translate
        }}</a
      >
    </ng-template>

    <div class="row mt-2 mb-3">
      <div class="d-block">
        <nz-select
          nzMode="multiple"
          [compareWith]="compareFn"
          nzShowSearch
          nzAllowClear
          [ngModel]="selectedCategories"
          (ngModelChange)="categorySelection($event)"
          [nzShowArrow]="true"
          [nzDisabled]="isLoading || !hasAdministrationUpdatePermission"
          [nzLoading]="isLoading"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="
            !hasAdministrationUpdatePermission
              ? forbiddenPermissionsMessage
              : ''
          "
        >
          @for (item of availableCategories; track item) {
            <nz-option
              [nzLabel]="item | translateActivityCategory"
              [nzValue]="item"
            >
            </nz-option>
          }
        </nz-select>
      </div>
    </div>
  </div>
  <button
    nz-button
    nzType="primary"
    class="text-dark p-1 px-2 fw-normal my-3"
    nz-tooltip
    nzTooltipPlacement="right"
    [nzTooltipTitle]="
      !hasAdministrationUpdatePermission ? forbiddenPermissionsMessage : ''
    "
    [disabled]="
      (!listToUpdate.unselectedList.length &&
        !listToUpdate.selectedList.length) ||
      isSaving ||
      !hasAdministrationUpdatePermission
    "
    (click)="submitWithConfirmation()"
  >
    {{ 'general.save_changes' | translate }}
  </button>
</div>
